import { render, staticRenderFns } from "./GoalEditScreen.vue?vue&type=template&id=02d50e0a&"
import script from "./GoalEditScreen.vue?vue&type=script&lang=js&"
export * from "./GoalEditScreen.vue?vue&type=script&lang=js&"
import style0 from "./GoalEditScreen.vue?vue&type=style&index=0&id=02d50e0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports